<template>
  <el-dialog :visible.sync="shouldShow" @close="closeEvent" width="50%">
    <template slot="title">
      <span class="title">AuthX - USER SUMMARY</span>
    </template>
    <div v-if="loading" v-loading="loading" class="loading"></div>
    <div v-else class="authx-app--user">
      <el-row type="flex" :gutter="20">
        <el-col :md="8">
          <div class="authx-app--user__summary">
            <div class="switch">
              <el-tooltip
                class="item"
                effect="dark"
                content="Activate/Deactivate User (in progress)"
                placement="top"
              >
                <el-switch
                  v-model="user.status.active"
                  :active-value="true"
                  :inactive-value="false"
                  disabled
                />
              </el-tooltip>
            </div>
            <div class="image">
              <ra-avatar :size="56" />
            </div>
            <div class="properties">
              <div class="property">
                <span>Identifier</span>
                <p>{{ user.identifier }}</p>
              </div>
              <div class="property">
                <span>Date Joined</span>
                <p>{{ mFormatDate(user.created, "Do MMM, yyyy") }}</p>
              </div>
              <div class="property">
                <span>Last active</span>
                <p>{{ mFormatDate(user.updated, "Do MMM, yyyy") }}</p>
              </div>
            </div>
            <div class="tag">
              <el-tag
                :type="user.status.active ? 'success' : 'danger'"
                size="small"
                >{{ user.status.label }}</el-tag
              >
            </div>
          </div>
        </el-col>
        <el-col :md="16">
          <div class="authx-app--user__overview">
            <div class="section">
              <div class="section-title">
                <p>Additional Information</p>
              </div>
              <el-row
                v-if="user.additional_information.length"
                type="flex"
                class="flex-wrap"
                :gutter="30"
              >
                <el-col
                  v-for="(info, index) in user.additional_information"
                  :key="index"
                  :md="8"
                >
                  <div class="property">
                    <span>{{ info.label }}</span>
                    <p>{{ info.value }}</p>
                  </div>
                </el-col>
              </el-row>
              <p v-else>-</p>
            </div>
            <div class="section">
              <div class="section-title">
                <p>Activities</p>
                <el-radio-group v-model="period" size="mini">
                  <el-radio-button label="yesterday">Yesterday</el-radio-button>
                  <el-radio-button label="today">Today</el-radio-button>
                  <el-radio-button label="thisweek">This week</el-radio-button>
                </el-radio-group>
              </div>
              <div class="event-table">
                <el-table :data="events" :empty-text="'No events'">
                  <el-table-column prop="name">
                    <template slot="header">
                      <span class="ra-table--header">
                        Event name
                      </span>
                    </template>
                    <template slot-scope="scope">
                      <p>{{ scope.row.name }}</p>
                    </template>
                  </el-table-column>
                  <el-table-column prop="date">
                    <template slot="header">
                      <span class="ra-table--header">
                        Time
                      </span>
                    </template>
                    <template slot-scope="scope">
                      <p>{{ scope.row.time }}</p>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </el-dialog>
</template>

<script>
import apiConstants from "@/apiConstants";

export default {
  name: "AuthxAppUser",
  props: {
    show: {
      type: Boolean,
      default: true
    },
    appCode: {
      type: String,
      default: ""
    },
    userCode: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      loading: false,
      period: "today",
      user: {
        status: {
          active: false,
          label: "Inactive"
        },
        identifier: "",
        created: "",
        updated: "",
        additional_information: []
      },
      events: []
    };
  },
  computed: {
    shouldShow: {
      get() {
        return this.show;
      },
      set(value) {
        this.$emit("update:show", value);
      }
    }
  },

  watch: {
    show() {
      if (this.show) {
        this.getUser();
      }
    }
  },
  methods: {
    closeEvent() {
      this.shouldShow = false;
      this.user = {
        status: {
          active: false,
          label: ""
        },
        identifier: "",
        created: "",
        updated: "",
        additional_information: []
      };
    },
    getUser() {
      this.loading = true;
      const apiUrl = `apps/${this.appCode}/users/${this.userCode}`;
      const params = `&embeds=["data", "status"]`;
      this.$http
        .post(
          apiUrl,
          {
            method: "GET",
            params: `${params}`
          },
          {
            headers: {
              "data-baseurl-namespace": apiConstants.URLS.AUTHX
            }
          }
        )
        .then(response => {
          const resData = response.data;
          if (resData.status === "error") {
            this.handleErrors(resData);
            this.loading = false;
          } else {
            const {
              created_at,
              identifier,
              modified_at,
              data,
              status
            } = resData;
            this.user.status.active = status.name === "active";
            this.user.status.label = status.label;
            this.user.identifier = identifier;
            this.user.created = created_at;
            this.user.updated = modified_at;

            if (data && data.data) {
              Object.keys(data.data).forEach(key => {
                this.user.additional_information.push({
                  label: key.replace("_", " "),
                  value: data.data[key]
                });
              });
            }
            this.loading = false;
          }
        })
        .catch(() => {
          this.notification("Error", "An unknown error occurred", "danger");
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.el-tag {
  font-size: 0.75rem;
}

.loading {
  height: 200px;
}

.authx-app--user {
  &__summary {
    border: 1px solid rgba(0, 0, 0, 0.1);
    padding: 30px 15px;
    border-radius: 8px;

    > div:not(:last-child) {
      margin-bottom: 20px;
    }

    .switch {
      display: flex;
      justify-content: flex-end;
    }

    .image {
      display: flex;
      justify-content: center;
    }

    .tag {
      text-align: center;
    }
    .properties {
      > div {
        margin-bottom: 12px;
      }
    }
  }

  &__overview {
    .el-table {
      padding: 0;
      margin-top: 20px;

      .ra-table--header {
        font-size: 0.7rem;
      }

      p {
        font-size: 0.75rem;
      }
    }
  }
}

.property {
  span {
    font-size: 0.7rem;
    text-transform: uppercase;
    font-weight: 400;
    opacity: 0.5;
  }

  p {
    font-size: 0.75rem;
    font-weight: 500;
    color: #140508;
  }
}

.section {
  margin-bottom: 40px;

  &-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;

    p {
      font-size: 0.75rem;
      text-transform: uppercase;
      color: var(--ra-primary);
    }
  }
}
</style>
